import { useQuery } from '@tanstack/react-query';

import type { GetMessageTemplatesParams } from 'api/MessageTemplatesApi';
import { MessageTemplatesApi } from 'api/MessageTemplatesApi';
import { MESSAGE_TEMPLATES_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useMessageTemplates(params?: GetMessageTemplatesParams) {
  const messageTemplatesApi = new MessageTemplatesApi();
  const { userBankId } = useUser();

  const { data: messageTemplates, isLoading: isLoadingMessageTemplates } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [MESSAGE_TEMPLATES_KEY, userBankId, params],
    queryFn: () => messageTemplatesApi.getMessageTemplatesForBank(userBankId, params)
  });

  return { messageTemplates, isLoadingMessageTemplates };
}
